var swiper = new Swiper(".splashBannerSwiper", {
  slidesPerView: 1,
  spaceBetween: 0,
  loop: true,
  autoplay: {
    delay: 6000,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".js-splash-banner-swiper-pagination",
    clickable: true,
  },
  navigation: {
    enabled: false,
    nextEl: ".js-splash-banner-swiper-button-next",
    prevEl: ".js-splash-banner-swiper-button-prev"
  },
  breakpoints: {
    640: {
      navigation: {
        enabled: false
      }
    },
    768: {
      navigation: {
        enabled: true
      }
    },
    1024: {
      navigation: {
        enabled: true
      }
    },
  },
});